// app/javascript/controllers/timer_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"] // The element where the time will be shown
  static values = {
    // Optional: if you want to start from a specific number or add a prefix/suffix
    // startTime: Number, // Could be used if you want to resume a timer
    // format: String, // e.g., "{time} seconds"
  }

  connect() {
    this.startTime = Date.now()
    this.running = true

    // Update immediately to show 0.0s or the initial state
    this.updateDisplay()

    this.intervalId = setInterval(() => {
      if (this.running) {
        this.updateDisplay()
      }
    }, 100) // Update every 100ms for smoother display of tenths of a second
  }

  updateDisplay() {
    if (!this.startTime) return // Should not happen if connected properly

    const elapsedMilliseconds = Date.now() - this.startTime
    const elapsedSeconds = elapsedMilliseconds / 1000

    // Update the target element
    // You can customize the formatting here
    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = `${elapsedSeconds.toFixed(1)}s`
    }
  }

  // Optional: Action to stop the timer if needed from an event
  stop() {
    this.running = false
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null // Clear the ID
    }
    // Final update
    this.updateDisplay()
  }

  // Optional: Action to resume the timer
  // resume() {
  //   if (!this.running) {
  //     // Adjust startTime to account for the paused duration
  //     // This part can be tricky if you want precise resume from pause.
  //     // For simplicity, restarting or adjusting might be easier.
  //     // For now, let's assume 'stop' is a final stop.
  //     // Or if you want to restart:
  //     // this.startTime = Date.now();
  //     // this.running = true;
  //     // this.intervalId = setInterval(() => this.updateDisplay(), 100);
  //   }
  // }

  disconnect() {
    this.stop() // Ensure timer is stopped and interval is cleared
  }
}
